import { useEffect, useState } from "react";
import useCustomerBranding from "../../data/CustomerBranding/useCustomerBrandingMutations";
import { ICustomer } from "../../models/Customer/Customer";
import Card from "../shared/Card/Card";
import { Button } from "../base/Button";
import { TextInput } from "../shared/Inputs/TextInput";
import { FormTextField } from "../base/Form/FormTextField";
import { useForm } from "react-hook-form";
import decimalToHex from './../../utils/decimalToHex';
import hexToDecimal from "../../utils/hexToDecimal";

interface EditCustomerBrandingFormFields {
  primaryColour: string;
  secondaryColour: string;
}

export default function EditCustomerBranding({ customer }: { customer: ICustomer }) {
  const { upload, updateColour } = useCustomerBranding(customer.id);
  const { register, handleSubmit, reset, watch } = useForm<EditCustomerBrandingFormFields>();
  const [logo, setLogo] = useState<File | null>(null);
  const [croppedLogo, setCroppedLogo] = useState<File | null>(null);
  const [widgetEmailDisplayLogo, setWidgetEmailDisplayLogo] = useState<File | null>(null);

  const handleLogoUpload = (file: File | null, isCropped: boolean, isWidgetEmailDisplayLogo: boolean) => {
    if (file) {
      const formData = new FormData();
      formData.append('file', file);

      upload.mutate({
        brandId: customer.brand?.id!,
        isCropped,
        isWidgetEmailDisplayLogo,
        data: formData
      });
    }
  };

  useEffect(() => {
    reset({
      primaryColour: decimalToHex(customer.brand?.primaryColour) || "",
      secondaryColour: decimalToHex(customer.brand?.secondaryColour) || ""
    });
  }, [customer]);

  const onSubmit = (data: EditCustomerBrandingFormFields) => {
    console.log(data);
    const body = {
      brandId: customer.brand?.id,
      primaryColour: hexToDecimal(data.primaryColour),
      secondaryColour: hexToDecimal(data.secondaryColour)
    };

    updateColour.mutate(body);
  }

  return (
    <Card title="Branding">
      <form onSubmit={handleSubmit(onSubmit)} className="px-4 py-2 divide-y divide-gray-100">

        <div className="flex justify-between items-center py-2">
          <dt className="text-sm font-medium leading-6 text-gray-900">
            Main Logo
          </dt>
          <dd>
            <img src={customer.brand?.logo} className="h-10 w-auto object-contain" />
          </dd>
          <dd className="mt-1 text-sm leading-6 text-gray-700 md:col-span-2 md:mt-0">
            <input onChange={(e) => setLogo(e.target.files ? e.target.files[0] : null)} type="file" className="form-input" />
            <Button onClick={() => handleLogoUpload(logo, false, false)}>Upload</Button>
          </dd>

        </div>

        <div className="flex justify-between items-center py-2">
          <dt className="text-sm font-medium leading-6 text-gray-900">
            Cropped Logo
          </dt>
          <dd>
            <img src={customer.brand?.croppedLogo} className="h-10 w-auto object-contain" />
          </dd>
          <dd className="mt-1 text-sm leading-6 text-gray-700 md:col-span-2 md:mt-0">
            <input onChange={(e) => setCroppedLogo(e.target.files ? e.target.files[0] : null)} type="file" className="form-input" />
            <Button onClick={() => handleLogoUpload(croppedLogo, true, false)}>Upload</Button>
          </dd>
        </div>

        <div className="flex justify-between items-center py-2">
          <dt className="text-sm font-medium leading-6 text-gray-900">
            Widget Display Logo
          </dt>
          <dd>
            <img src={customer.brand?.widgetEmailDisplayLogo} className="h-10 w-auto object-contain" />
          </dd>
          <dd className="mt-1 text-sm leading-6 text-gray-700 md:col-span-2 md:mt-0">
            <input onChange={(e) => setWidgetEmailDisplayLogo(e.target.files ? e.target.files[0] : null)} type="file" className="form-input" />
            <Button onClick={() => handleLogoUpload(widgetEmailDisplayLogo, false, true)}>Upload</Button>
          </dd>

        </div>

        <div className="flex justify-between items-center py-2">
          <dt className="mr-4 text-sm font-medium leading-6 text-gray-900">
            Primary Colour
          </dt>
          <dd>
            <div className="w-32 h-10 rounded border border-gray-400" style={{ backgroundColor: watch("primaryColour") ? `#${watch("primaryColour")}` : "transparent" }} />
          </dd>
          <dd className="flex items-center gap-4 mt-1 text-sm leading-6 text-gray-700 md:col-span-2 md:mt-0">
            #<TextInput
              label=""
              register={register}
              registerName="primaryColour"
            />
          </dd>
        </div>

        <div className="flex justify-between items-center py-2">
          <dt className="text-sm font-medium leading-6 text-gray-900">
            Secondary Colour
          </dt>
          <dd>
            <div className="w-32 h-10 rounded border border-gray-400" style={{ backgroundColor: watch("secondaryColour") ? `#${watch("secondaryColour")}` : "transparent" }} />
          </dd>
          <dd className="flex items-center gap-4 mt-1 text-sm leading-6 text-gray-700 md:col-span-2 md:mt-0">
            #<TextInput
              label=""
              register={register}
              registerName="secondaryColour"
            />
          </dd>
        </div>

        <div className="flex justify-end py-2">
          <Button type="submit">Save</Button>
        </div>

      </form>
    </Card>
  )
}